import React from 'react'; 
import './styles.less';

/********************************************
 *  This adds a filtered background image to
 *  the containing div. Meant to be used in
 *  headers.
 *  
 *  See the styles.less for the filter vals:
 *  
 *  .overlay-filter {
 *     background-color: rgba(0, 0, 0, 0.5);
 *   }
 * 
 *  Add the image src in theme's css:
 * 
 *  Example:
 *  .filtered-image {
 *     background-image: url(...);
 *  }
 ***************************************/
 
const FilteredImage = ( { children } ) => {         
    return (
        <div className="filtered-image">
             <div className="overlay-filter">
                { children }
             </div>
        </div>
    );
};

export default FilteredImage;
 